import { render, staticRenderFns } from "./parkInfo.vue?vue&type=template&id=2239fe76&scoped=true"
import script from "./parkInfo.vue?vue&type=script&lang=js"
export * from "./parkInfo.vue?vue&type=script&lang=js"
import style0 from "./parkInfo.vue?vue&type=style&index=0&id=2239fe76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2239fe76",
  null
  
)

export default component.exports